import React from 'react';
import { ArrowLeft } from 'lucide-react';
import './screens.css';

const UnauthenticatedScreen = ({ goToHome, onLogin }) => {
  return (
    <div className="unauthenticated-container">
      <div className="unauthenticated-content">
        <h2 className="unauthenticated-title">ログインが必要です</h2>
        <p className="unauthenticated-message">
          このページを表示するには、LINEログインが必要です。
        </p>
        <p className="unauthenticated-explanation">
          アプリの閲覧(URLから直接アクセス)はログインなしでも可能ですが、ホーム画面、アプリ一覧やアプリ作成、いいね機能はLINEログインが必要です。
        </p>
        
        <div className="unauthenticated-buttons">
          <button className="login-button" onClick={onLogin}>
            LINEでログイン
          </button>
          <button className="back-button" onClick={goToHome}>
            <ArrowLeft size={18} />
            ホームに戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthenticatedScreen;
